import React from "react";
import "./generic.scss";
import { Link } from "react-router";

export default function Button({
  children,
  href,
  action = null,
  submit = false,
  disabled = false,
  title,
  target = "_blank",
  loading = false,
  id = "",
  btnClass
}) {
  const Loading = () => <div className="loader-indicator"></div>;

  function validateLink(link) {
    let temp = link;

    if (action === null && temp === undefined && submit === false) {
      return (
        <div className={`button ${disabled ? "disabled" : ""}`} title={title}>
          <div className="button-inner">{children}</div>
        </div>
      );
    } else if (submit === true) {
      return (
        <button
          type="submit"
          value={children}
          className={`button ${disabled ? "disabled" : ""}`}
          disabled={disabled}
          title={title}
        >
          <div className="button-inner">{children}</div>
        </button>
      );
    } else if (action !== null && link === undefined) {
      return (
        <button
          className={`button ${disabled || loading ? "disabled" : ""}`}
          onClick={action}
          title={title}
          disabled={disabled || loading}
        >
          {!loading ? (
            <div className="button-inner">{children}</div>
          ) : (
            <Loading />
          )}
        </button>
      );
    } else if (temp.includes("http://") || temp.includes("https://") || temp.includes("mailto")) {
      return (
        <a
          href={href}
          target={target}
          rel="noopener noreferrer"
          className={`button ${disabled ? "disabled" : ""}`}
          title={title}
          onClick={action}
        >
          <div className="button-inner">{children}</div>
        </a>
      );
    } else {
      return (
        <Link
          to={href}
          className={`button ${disabled || loading ? "disabled" : ""}`}
          title={title}
          onClick={action}
        >
          {!loading ? (
            <div className="button-inner">{children}</div>
          ) : (
            <Loading />
          )}
        </Link>
      );
    }
  }

  return (
    <div
      id={id}
      className={`button-component ${disabled || loading ? "disabled" : ""} ${btnClass ? btnClass : ""}`}
    >
      {validateLink(href)}
    </div>
  );
}
